import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  T2CardComponent
} from '../../../trip2-theme/components/t2-card/t2-card.component';
import {
  UsersService
} from '../users.service';

@Component({
  selector: 'app-users-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {
  @Output() notify: EventEmitter < boolean >= new EventEmitter < boolean > ();
  @Input() usersId: number;
  @Input() enabledDeleteBtn = false;
  @ViewChild('modalUsersDelete') modal: T2CardComponent;
  constructor(private service: UsersService) {}

  ngOnInit() {}

  /**
   * @Description:
   * @param data
   */
  sendNotify(data: any) {
    if (data.success) {
      this.notify.emit(data);
    } else {
      alert(data.message);
    }
  }

  /**
   * @Description:
   */
  deleteAction(): void {
    if (this.usersId === 0) {
      alert('Select one record');
    } else {
      this.modal.open();
    }
  }

  /**
   * @Description:
   */
  saveAction(): void {
    this.modal.viewProgressBar(true);
    this.service
    .deleteData(this.usersId)
    .finally(() => {
      this.modal.viewProgressBar(false);
    })
    .subscribe(
      res => this.sendNotify(res)
    );
    this.modal.close();
  }

  /**
   * @name open
   * @description Abrir modal
   */
  open() {
    this.modal.open();
  }

  /**
   * @name close
   * @description Cerrar modal
   */
  close() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/users/delete/delete.component.ts